var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.className ? _vm.className + ' ': '') + 'col-md-12 text-center title-logo-png'},[_c('a',{attrs:{"href":_vm.url}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../../public/img/logo.png"),"alt":"logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }